import apiClient from './apiClient';

const cancellationPolicyService = {
  getAll: () => apiClient.get('/reservations/cancellation-policies/'),
  getById: (id) => apiClient.get(`/reservations/cancellation-policies/${id}/`),
  create: (data) => apiClient.post('/reservations/cancellation-policies/', data),
  update: (id, data) => apiClient.patch(`/reservations/cancellation-policies/${id}/`, data),
  remove: (id) => apiClient.del(`/reservations/cancellation-policies/${id}/`),
};

export default cancellationPolicyService;
